import { AnyAction, combineReducers } from 'redux'
import * as types from './types'
import { IProductGroup, IProductGroupListItem } from '@cbgms/api'

const list = (state: IProductGroupListItem[] = [], action: AnyAction) => {
  switch (action.type) {
    case types.LOAD_PRODUCT_TREES_SUCCESS:
      return action.payload.data.Data as IProductGroupListItem[]
    default:
      return state
  }
}

const tree = (state: IProductGroup | null = null, action: AnyAction) => {
  switch (action.type) {
    case types.LOAD_PRODUCT_TREE_SUCCESS:
      return action.payload.data.Data as IProductGroup
    default:
      return state
  }
}

const productGroup = combineReducers({
  list,
  tree
})

export default productGroup
